import * as React from 'react'
import { withRouter } from 'next/router'
import { convertCreatorCategoryToListProps } from '../../models/Creator'
import type { CreatorListPropsType } from '../../models/Creator'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { CreatorList } from '@components/Creator/CreatorList'
function Creators (props: CreatorListPropsType): React.ReactNode {
  return (
    <DiscoverLayout title={`Listen to Top Creators on Dipsea`}>
        <CreatorList {...props}/>
    </DiscoverLayout>
  )
}
export default withRouter(Creators as any) as any

export async function getStaticProps (): Promise<{ props: CreatorListPropsType }> {
  const props = await convertCreatorCategoryToListProps()
  return { props }
}
